export default __webpack_public_path__ + "static/media/YOOZ-HOW-TO-SCAN-A-QRCODE.9f36cd6b.mp4";